import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import GeoCodeJSON from '../models/GeoCode/GeoCodeJSON';

@Injectable({
  providedIn: 'root'
})
export class AdresseGouvService {
  public static readonly BASE_URL:string = "https://api-adresse.data.gouv.fr";

  constructor(private _http: HttpClient) { 
  }

  search(adresse:string){
    return this._http.get<GeoCodeJSON>(AdresseGouvService.BASE_URL+'/search',{
        params : {
            q : adresse,
            limit: "5"
        }
    });
}


}
